module.exports = __webpack_public_path__ + "static/media/search_black.b21f3143.svg";